import { createContext, useContext, useEffect, useRef, useState } from 'react'
import NTree from "./NTree"
import axios from 'axios';
import { Checkbox, CircularProgress, FormControlLabel, TablePagination } from '@mui/material'
import { labelDisplayedRows, nDigits } from '../utils/utils';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { Menu, MenuItem, Typeahead } from 'react-bootstrap-typeahead';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { isObjectEmpty, paramsSerializer } from '../utils/utils'
import AddSC from './AddSC';
import { api } from "../services/config"
import { ProjectContext } from '../screens/ProjectScreen';
import { useOutletContext } from 'react-router-dom';
import Paginate from './Paginate';

export const SemanticTreeContext = createContext();

function SemanticTree({ style, triggerRender, setAssociatedClicked, setSemanticClicked, splittedTree }) {
    const {
        termData, setTermData,
        setTreeState,
        headers,
    } = useContext(ProjectContext);
    const [showAssociated, setShowAssociated] = useState(false);
    const [showRelated, setshowRelated] = useState(false);

    const [terms, setTerms] = useState([])
    const [query, setQuery] = useState({
        surface_regex: "",
        sort: (["reference"]),
        in_semantic: true,
    })
    const [loading, setLoading] = useState(false)
    const [keywordId, setKeywordId] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const [hyponyms, setHyponyms] = useState();
    const [semanticTerm, setSemanticTerm] = useState()
    const [semantic, setSemantic] = useState();
    const [smShow, setSmShow] = useState(false);
    const [message, setMessage] = useState();
    const [addSCIsOpen, setAddSCIsOpen] = useState(false);

    const [semanticRoot, setSemanticRoot] = useState([])
    const [count, setCount] = useState(0)
    const [page, setPage] = useState(0)
    const [pageChanged, setPageChanged] = useState(false)
    const [rows, setRows] = useState({})
    const [occruPage, setOccruPage] = useState(1)

    const [selectedSC, setSelectedSC] = useState({})
    const listRef = useRef(null);
    const isInitialRender = useRef(true);

    const [inputMenu, setInputMenu] = useState(false)
    const [showFullList, setShowFullList] = useState(false)

    const { profileState } = useOutletContext();
    const { projectRole: { projectId, role } } = profileState

    const scrollToItem = (index) => {
        const itemRef = listRef?.current.children[index];
        itemRef?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    useEffect(() => {
        async function fetchTerms(limit = 100, offset = 0) {
            query.limit = limit
            query.offset = offset
            await axios.get(
                `${api.project}${projectId}/terms/`,
                {
                    params: query,
                    paramsSerializer,
                },
                { headers }
            )
                .then(res => {
                    setTerms(res.data.terms)
                    setLoading(true)
                })
                .catch(
                    function (error) {
                        return Promise.reject(error)
                    }
                )
        }
        setLoading(false)
        fetchTerms()
    }, [headers, projectId, query])

    useEffect(() => {
        if (inputMenu) {
            setTimeout(() => {
                setShowFullList(true);
            }, 1000);
        }
    }, [inputMenu])

    useEffect(() => {
        if (!isInitialRender.current) {
            if (termData.vedette_class) {
                setIsLoading(true);
                setPage(0);
                setOccruPage(1);
                setSemanticTerm([termData])
                getSemanticPath(0, null, [termData], true);
            }
        } else {
            isInitialRender.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [triggerRender]);

    const handleTermInputChange = queryString => {
        if (queryString.length > 2) {
            setTerms([])
            setQuery({
                ...query,
                surface_regex: queryString ? `(^${queryString})` : ""
            });
        }
        else if (queryString.length <= 2 && query.surface_regex.length >= 6) {
            setTerms([])
            setQuery({
                ...query,
                surface_regex: ""
            });
        }
    };

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
        !hyponyms && setPageChanged(true);
        hyponyms && getSemanticPath(newPage)
    };

    async function getSemanticPath(newPage, scrollToItem_, term, resultsPage = false) {
        const semanticTerm_ = term || semanticTerm
        if (semanticTerm_?.length > 0) {
            setIsLoading(true)
            const params = {
                offset: newPage * 100,
                limit: 100,
                first_with_results: resultsPage,
            };
            const term_ = semanticTerm_?.[0];
            const params_ = {
                ids: [...new Set((term_.vedette_class ? [term_.vedette_class] : []).concat(term_?.classes || []))]
            }
            const { data } = await axios.put(
                `${api.project}${projectId}/sc/paths/`,
                params_,
                { params, paramsSerializer }
            )
            setIsLoading(false)
            setHyponyms(data.classes);
            setRows(data.rows);
            setCount(data.count);
            setKeywordId(term_.id);
            (!term_.vedette_class || params_.ids.length > 1) && setshowRelated(true)
            // If resultsPage is true (used for first search)
            // Determine page based on first semantic index in rows
            let newPageNum = newPage;
            if (resultsPage && data.rows && Object.keys(data.rows).length > 0) {
                const firstSemanticIndex = Object.keys(data.rows)[0] - 1;
                const pageNum = nDigits(String(firstSemanticIndex), 3);
                if (pageNum !== 0) {
                    setPage(pageNum);
                    newPageNum = pageNum;
                }
            }
            setSemanticTerm(semanticTerm_);
            setTimeout(() => {
                if (scrollToItem_) scrollToItem_();
                else {
                    const semanticIndex = Object.keys(data.rows)?.[0] - 1;
                    if (nDigits(String(semanticIndex), 3) === newPageNum) scrollToItem(semanticIndex - newPageNum * 100)
                    else setOccruPage(0)
                }
            }, 100);
        }
        else {
            noSelectedSemanticMsg();
        }
        setIsLoading(false)
    }

    const showAssociatedHandleChange = (event) => {
        setShowAssociated(event.target.checked);
    };
    const showRelatedHandleChange = (event) => {
        setshowRelated(event.target.checked);
    };

    async function handleDelete_(semantic) {
        if (semantic.hyponyms.length > 0) {
            setMessage('Vous ne pouvez pas supprimer cette classe car elle contient des hyponymes')
            setSmShow(true)
        }
        else {
            await axios.delete(`${api.project}${projectId}/sc/`, {
                data: { ids: [semantic.id] },
                headers
            })
                .then(() => {
                    setSemanticTerm([])
                    setSemantic()
                    setSelectedSC({})
                    setTermData(termData => ({ ...termData, vedette_class: null }))

                    setTreeState({
                        item: `semantic-${semantic.id}`,
                        updatedSemantics: semantic.hypernyms.length > 0
                            ? semantic.hypernyms.map(hypernym => hypernym.id)
                            : [0],
                    });
                })
                .catch(
                    function (error) {
                        return Promise.reject(error)
                    }
                )
        }
    }

    async function handleDelete() {
        if (!semantic) {
            if (!isObjectEmpty(semanticTerm?.[0]) && semanticTerm?.[0]?.vedette_class) {
                await axios.put(
                    `${api.project}${projectId}/sc/`,
                    { "ids": [semanticTerm[0].vedette_class] },
                    { headers }
                )
                    .then(async (res) => {
                        await handleDelete_(res.data.classes[0])
                    })
            }
            else {
                noSelectedSemanticMsg();
            }
        } else {
            await handleDelete_(semantic)
        }
    }

    async function handleEdit() {
        if (!semantic) {
            if (!isObjectEmpty(semanticTerm?.[0]) && semanticTerm?.[0]?.vedette_class) {
                await axios.put(
                    `${api.project}${projectId}/sc/`,
                    { "ids": [semanticTerm[0].vedette_class] },
                    { headers }
                )
                    .then(async (res) => {
                        setSemantic(res.data.classes[0])
                        setAddSCIsOpen(true)
                    })
            }
            else {
                noSelectedSemanticMsg();
            }
        } else {
            setAddSCIsOpen(true)
        }
    }

    const updatedSemantic = (semantic, term) => {
        setSemanticTerm([term])
        setSemantic(semantic)
    };

    const handleOccurChange = (occurPage) => {
        setOccruPage(occurPage)
        const semanticIndex = Object.keys(rows)?.[occurPage - 1] - 1;
        // Check if semanticIndex is in current page
        if (page * 100 <= semanticIndex && semanticIndex < (page + 1) * 100) {
            scrollToItem(semanticIndex - page * 100)
        }
        // If not, change page
        else {
            const newPage = nDigits(String(semanticIndex), 3)
            setPage(newPage);
            getSemanticPath(newPage, () => scrollToItem(semanticIndex - newPage * 100))
        }
    }

    const noSelectedSemanticMsg = () => {
        setMessage('Veuillez sélectionner une classe sémantique')
        setSmShow(true)
    }

    const resetSearch = () => {
        setHyponyms();
        setKeywordId();
        setSemanticTerm();
    };

    return (
        <div className="semantic_tab" style={style}>
            {addSCIsOpen && <Modal
                show={addSCIsOpen}
                onHide={() => setAddSCIsOpen(false)}
                aria-labelledby="add-sc-modal-sizes-title-md"
                dialogClassName="w-90"
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <AddSC
                        semantic={semantic}
                        setSemantic={setSemantic}
                        setAddSCIsClose={setAddSCIsOpen}
                    />
                </Modal.Body>
            </Modal>}
            {smShow && <Modal
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
                dialogClassName="w-75"
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>{message}</Modal.Body>
            </Modal>}
            <span className="ml-3">
                <FormControlLabel
                    className="mb-0"
                    control={<Checkbox
                        checked={showAssociated}
                        onChange={showAssociatedHandleChange}
                        inputProps={{ "aria-label": "controlled" }}
                        color="default"
                        size="small"
                    />}
                    label="Classes Associées"
                />
                <FormControlLabel
                    className="mb-0"
                    control={<Checkbox
                        checked={showRelated}
                        onChange={showRelatedHandleChange}
                        inputProps={{ "aria-label": "controlled" }}
                        color="default"
                        size="small"
                    />}
                    label="Termes liés"
                />
            </span>

            <Form.Group as={Row} className="my-1 mx-0" controlId="">
                <Col sm="6" xs="12">
                    <Typeahead
                        className={semanticTerm && !isObjectEmpty(semanticTerm) ? `typeaheadSelected` : ""}
                        id="search-class"
                        onMenuToggle={(isOpen) => {
                            setInputMenu(isOpen);
                            !isOpen && setShowFullList(false);
                        }}
                        onChange={(data) => {
                            setTerms([]);
                            setSemanticTerm([]);
                            setSemantic();
                            if (data?.length > 0) {
                                setIsLoading(true);
                                setPage(0);
                                setOccruPage(1);
                                getSemanticPath(0, null, data, true);
                            }
                        }}
                        labelKey="reference"
                        renderMenu={(results, menuProps) => (
                            <Menu {...menuProps}>
                                {results.map((result, index) => (
                                    <MenuItem option={result} position={index}>
                                        <span>
                                            {result.reference}
                                        </span>
                                        <span className="opacity-50 f-s-13 ">
                                            {result?.form?.source?.label}
                                        </span>
                                    </MenuItem>
                                ))}
                            </Menu>
                        )}
                        emptyLabel={
                            !loading
                                ? "Recherche..."
                                : "Aucune correspondance trouvée"
                        }
                        options={showFullList ? terms : terms.slice(0, 5)}
                        onInputChange={handleTermInputChange}
                        filterBy={() => true}
                        placeholder="Sélectionnez une classe..."
                        selected={semanticTerm || []}
                        minLength={3}
                    />
                </Col>
                <Col sm="4" xs="6" className="">
                    <Row>
                        {hyponyms && (
                            <Button
                                title="Actualiser l'arbre des classes"
                                size="sm"
                                className="ml-2"
                                variant="info"
                                onClick={resetSearch}
                            >
                                <i className="fas fa-redo" />
                            </Button>
                        )}
                        {isLoading && (
                            <CircularProgress
                                className="mt-1 mr-3"
                                size={24}
                                style={{ marginLeft: 15, position: "relative", top: 4 }}
                            />
                        )}
                        {role > 0 && (
                            <div>
                                <Button
                                    title="Modifier la classe"
                                    size="sm"
                                    className="ml-1"
                                    variant="warning"
                                    onClick={handleEdit}
                                >
                                    <EditIcon />
                                </Button>
                                <Button
                                    title="Supprimer la classe"
                                    size="sm"
                                    className="ml-1"
                                    variant="danger"
                                    onClick={handleDelete}
                                >
                                    <DeleteIcon />
                                </Button>
                            </div>
                        )}
                    </Row>
                </Col>
            </Form.Group>
            <div className="d-flex align-items-center ml-3">
                {hyponyms &&
                    <Paginate
                        count={Object.keys(rows).length}
                        page={occruPage}
                        onPageChange={handleOccurChange}
                    />
                }
                <TablePagination
                    className="ml-auto"
                    component="div"
                    count={count}
                    page={page}
                    rowsPerPage={100}
                    rowsPerPageOptions={[]}
                    onPageChange={handleChangePage}
                    labelDisplayedRows={labelDisplayedRows}
                />
            </div>

            {((hyponyms && !isLoading) || !hyponyms) && <SemanticTreeContext.Provider
                value={{
                    semanticRoot, setSemanticRoot,
                    selectedSC, setSelectedSC,
                    updatedSemantic,
                    related: showRelated,
                    associated: showAssociated,
                    keywordId,
                    setAssociatedClicked,
                    setSemanticClicked,
                    splittedTree,
                    setCount,
                    page,
                    hyponyms, resetSearch,
                }}
            >
                {!hyponyms ? (
                    <NTree
                        root={true}
                        pageChanged={pageChanged}
                        setPageChanged={setPageChanged}
                    />
                ) : (
                    <NTree
                        root={true}
                        hyponyms={hyponyms}
                        onListRef={(ref) => {
                            listRef.current = ref;
                        }}
                    />
                )}
            </SemanticTreeContext.Provider>}

        </div>
    );
}

export default SemanticTree
